"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip as TooltipPrimitive } from "@base-ui-components/react/tooltip";
import { useCallback, useEffect, useRef, useState } from "react";
import { tooltipVariants } from "../../styles/utils/tooltip";
import { classNames } from "../../utils";
import { TextLabel } from "../Text";
export function TooltipLabel(t0) {
  const $ = _c(12);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("normal-case", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <p>{children}</p>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== rest || $[9] !== t1 || $[10] !== t2) {
    t3 = <TextLabel asChild={true} className={t1} size="sm" {...rest}>{t2}</TextLabel>;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
/**
 * A popup that displays information related to an element when the element receives keyboard focus or the mouse hovers over it.
 */
export function Tooltip(t0) {
  const $ = _c(70);
  let anchor;
  let attachToCursor;
  let children;
  let className;
  let container;
  let content;
  let defaultOpen;
  let disablePointerEvents;
  let disabled;
  let hoverable;
  let onOpenChange;
  let open;
  let props;
  let style;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t0) {
    ({
      open,
      defaultOpen,
      onOpenChange,
      content,
      children,
      className,
      disabled,
      delay: t1,
      hoverable,
      align: t2,
      alignOffset: t3,
      sideOffset: t4,
      animation: t5,
      disablePointerEvents,
      attachToCursor,
      side: t6,
      style,
      anchor,
      container,
      cursorClassName: t7,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = anchor;
    $[2] = attachToCursor;
    $[3] = children;
    $[4] = className;
    $[5] = container;
    $[6] = content;
    $[7] = defaultOpen;
    $[8] = disablePointerEvents;
    $[9] = disabled;
    $[10] = hoverable;
    $[11] = onOpenChange;
    $[12] = open;
    $[13] = props;
    $[14] = style;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    anchor = $[1];
    attachToCursor = $[2];
    children = $[3];
    className = $[4];
    container = $[5];
    content = $[6];
    defaultOpen = $[7];
    disablePointerEvents = $[8];
    disabled = $[9];
    hoverable = $[10];
    onOpenChange = $[11];
    open = $[12];
    props = $[13];
    style = $[14];
    t1 = $[15];
    t2 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
  }
  const delay = t1 === undefined ? 100 : t1;
  const align = t2 === undefined ? "center" : t2;
  const alignOffset = t3 === undefined ? 0 : t3;
  const sideOffset = t4 === undefined ? 8 : t4;
  const animation = t5 === undefined ? "fade-in" : t5;
  const side = t6 === undefined ? "top" : t6;
  const cursorClassName = t7 === undefined ? "cursor-pointer" : t7;
  const [openedState, setOpenedState] = useState(Boolean(defaultOpen ?? open));
  const resolvedOpenState = open === undefined ? openedState : open;
  const triggerRef = useRef(null);
  let t8;
  if ($[22] !== onOpenChange) {
    t8 = (...t9) => {
      const args = t9;
      const [open_0] = args;
      setOpenedState(open_0);
      onOpenChange?.(...args);
    };
    $[22] = onOpenChange;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const handleOnOpenChange = t8;
  let t10;
  let t9;
  if ($[24] !== attachToCursor || $[25] !== handleOnOpenChange || $[26] !== resolvedOpenState) {
    t9 = () => {
      const handleMouseMove = e => {
        if (triggerRef.current) {
          const rect = triggerRef.current.getBoundingClientRect();
          const isOutside = e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom;
          if (isOutside) {
            handleOnOpenChange(false, undefined, undefined);
          }
        }
      };
      if (resolvedOpenState && attachToCursor) {
        document.addEventListener("mousemove", handleMouseMove);
      }
      return () => {
        document.removeEventListener("mousemove", handleMouseMove);
      };
    };
    t10 = [resolvedOpenState, attachToCursor, handleOnOpenChange];
    $[24] = attachToCursor;
    $[25] = handleOnOpenChange;
    $[26] = resolvedOpenState;
    $[27] = t10;
    $[28] = t9;
  } else {
    t10 = $[27];
    t9 = $[28];
  }
  useEffect(t9, t10);
  if (disabled || !content) {
    let t11;
    if ($[29] !== children) {
      t11 = <>{children}</>;
      $[29] = children;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    return t11;
  }
  const t11 = attachToCursor ? "both" : undefined;
  const t12 = !disabled && cursorClassName;
  let t13;
  if ($[31] !== t12) {
    t13 = classNames(t12);
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== attachToCursor || $[34] !== handleOnOpenChange) {
    t14 = () => {
      if (attachToCursor) {
        handleOnOpenChange(false, undefined, undefined);
      }
    };
    $[33] = attachToCursor;
    $[34] = handleOnOpenChange;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== children || $[37] !== t13 || $[38] !== t14) {
    t15 = <TooltipPrimitive.Trigger className={t13} onPointerLeave={t14} ref={triggerRef} render={children} />;
    $[36] = children;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  const t16 = disablePointerEvents ? "pointer-events-none" : undefined;
  let t17;
  if ($[40] !== t16) {
    t17 = classNames("z-tooltip", t16);
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== animation || $[43] !== className) {
    t18 = classNames(tooltipVariants({
      animation,
      className: "p-2"
    }), className);
    $[42] = animation;
    $[43] = className;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== content || $[46] !== props || $[47] !== style || $[48] !== t18) {
    t19 = <TooltipPrimitive.Popup className={t18} role="tooltip" style={style} {...props}>{content}</TooltipPrimitive.Popup>;
    $[45] = content;
    $[46] = props;
    $[47] = style;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== align || $[51] !== alignOffset || $[52] !== anchor || $[53] !== side || $[54] !== sideOffset || $[55] !== t17 || $[56] !== t19) {
    t20 = <TooltipPrimitive.Positioner align={align} alignOffset={alignOffset} anchor={anchor} className={t17} side={side} sideOffset={sideOffset}>{t19}</TooltipPrimitive.Positioner>;
    $[50] = align;
    $[51] = alignOffset;
    $[52] = anchor;
    $[53] = side;
    $[54] = sideOffset;
    $[55] = t17;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== container || $[59] !== t20) {
    t21 = <TooltipPrimitive.Portal container={container}>{t20}</TooltipPrimitive.Portal>;
    $[58] = container;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== defaultOpen || $[62] !== delay || $[63] !== handleOnOpenChange || $[64] !== hoverable || $[65] !== resolvedOpenState || $[66] !== t11 || $[67] !== t15 || $[68] !== t21) {
    t22 = <TooltipPrimitive.Root defaultOpen={defaultOpen} delay={delay} hoverable={hoverable} onOpenChange={handleOnOpenChange} open={resolvedOpenState} trackCursorAxis={t11}>{t15}{t21}</TooltipPrimitive.Root>;
    $[61] = defaultOpen;
    $[62] = delay;
    $[63] = handleOnOpenChange;
    $[64] = hoverable;
    $[65] = resolvedOpenState;
    $[66] = t11;
    $[67] = t15;
    $[68] = t21;
    $[69] = t22;
  } else {
    t22 = $[69];
  }
  return t22;
}